import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import { pageMeta } from "@/lib/seo/meta";
import { TOOL_CACHE_HEADERS } from "@/lib/seo/headers";

const EmailToPdfView = lazy(() => import("@/features/email-to-pdf/view"));

export const Route = createFileRoute("/email-to-pdf")({
  head: () =>
    pageMeta({
      title: "Email to PDF",
      description:
        "Drop in a .eml file and get a print-ready PDF with the headers, body, and attachments included.",
      path: "/email-to-pdf",
      keywords: "email to pdf, eml to pdf, save email as pdf, online, free",
    }),
  headers: () => TOOL_CACHE_HEADERS,
  component: () => (
    <Suspense fallback={null}>
      <EmailToPdfView />
    </Suspense>
  ),
});
